import React from 'react';

import Parallax from '../common/Parallax.jsx';

function ShowImageParallaxComponent(props) {
    let show = props.data || {};
    if (show.show) {
        show = show.show;
    }
    const image = show.image;
    return <Parallax.ImageContainer.Component {...props} data={[{ show,  image }]} slideComponent={ShowImageParallaxCell} />
}

function ShowImageParallaxCell(props) {
    let show = props.data || {};
    if (show.show) {
        show = show.show;
    }
    const image = show.image;
    return <Parallax.ImageContainer.Cell {...props} image={image} />
}

export default { Cell: ShowImageParallaxCell, Component: ShowImageParallaxComponent };